import { Button } from "@similarweb/ui-components";

import { deleteButtonsKeys } from "./automationKeys";
import * as SC from "./styles";
import type { ButtonsConfigSchema, ButtonsNameSchema } from "./types";

type DeleteButtonsSchema = {
    config: Record<ButtonsNameSchema, ButtonsConfigSchema>;
};

const DeleteButtons = ({ config }: DeleteButtonsSchema) => (
    <SC.ButtonsWrapper isFirstButtonVisible={config.cancel.isVisible}>
        {config.cancel.isVisible ? (
            <Button
                dataAutomation={deleteButtonsKeys.closeButton}
                {...config.cancel}
            />
        ) : null}

        <div>
            {config.deleteTopicWithKW.isVisible ? (
                <SC.DeleteListButton
                    dataAutomation={deleteButtonsKeys.deleteTopicAndKW}
                    {...config.deleteTopicWithKW}
                />
            ) : null}

            <Button
                dataAutomation={deleteButtonsKeys.deleteTopic}
                {...config.deleteTopic}
            />
        </div>
    </SC.ButtonsWrapper>
);

export default DeleteButtons;
